<template>
  <div class="grid-row p1 pl2">
    <router-link to="/"><img src="../../static/header-logo.svg" class="icon--large" /></router-link>
  </div>
</template>

<script>
export default {
  name: 'head'
}
</script>

<style lang="scss" scoped>
   @import '../assets/scss/main.scss'
</style>



// WEBPACK FOOTER //
// src/components/Head.vue